import { createSlice } from "@reduxjs/toolkit";

export const layoutStore = createSlice({
  name: "layout",
  initialState: {
    menuActive: true,
    notFoundPage: false,
    floatingBarVisible: true,
  },
  reducers: {
    updateMenuActive: (state, action) => {
      state.menuActive =
        action.payload !== undefined ? action.payload : !state.menuActive;
    },
    showNotFoundPage: (state, action) => {
      state.notFoundPage = action.payload;
    },
    updateFloatingBarVisible: (state, action) => {
      state.floatingBarVisible = action.payload;
    },
  },
});

export const { updateMenuActive, showNotFoundPage, updateFloatingBarVisible } =
  layoutStore.actions;

export default layoutStore.reducer;
